export const CREDIT_ENROLLMENT_FAILED = 'CREDIT_ENROLLMENT_FAILED';

export const creditEnrollmentFailed = () => dispatch =>
  dispatch({
    type: CREDIT_ENROLLMENT_FAILED,
  });
